"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedOcsFormDefinition = exports.NormalizedAmrsFormDefinition = exports.NormalizedRatingsFormOutputSchema = exports.NormalizedRatingsFormOpenedOnSchema = exports.NormalizedRatingsFormInputSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const misc_1 = require("../../../misc");
const payload_1 = require("./payload");
exports.NormalizedRatingsFormInputSchema = payload_1.NormalizedRatingsFormPayloadSchema.extend({
    signals: sigma_engine_shared_1.SignalSchema.array(),
    datasheetFileId: z.string(),
    manufacturerPartNumber: z.string(),
    sequenceGate: misc_1.sequenceGateSchema,
});
exports.NormalizedRatingsFormOpenedOnSchema = z.object({
    modes: sigma_engine_shared_1.ModeBaseSchema.array(),
    differentialPairs: sigma_engine_shared_1.DifferentialPairSchema.array(),
});
exports.NormalizedRatingsFormOutputSchema = payload_1.NormalizedRatingsFormPayloadSchema.extend({
    openedOn: exports.NormalizedRatingsFormOpenedOnSchema.optional(),
});
exports.NormalizedAmrsFormDefinition = {
    type: 'NormalizedAmrsForm',
    displayName: 'Normalized absolute maximum ratings',
    inputSchema: exports.NormalizedRatingsFormInputSchema,
    outputSchema: exports.NormalizedRatingsFormOutputSchema,
};
exports.NormalizedOcsFormDefinition = {
    type: 'NormalizedOcsForm',
    displayName: 'Normalized operating conditions',
    inputSchema: exports.NormalizedRatingsFormInputSchema,
    outputSchema: exports.NormalizedRatingsFormOutputSchema,
};
//# sourceMappingURL=step-definition.js.map